import { render, staticRenderFns } from "./SendBackProvider.vue?vue&type=template&id=4338ce0e&scoped=true&"
import script from "./SendBackProvider.vue?vue&type=script&lang=ts&"
export * from "./SendBackProvider.vue?vue&type=script&lang=ts&"
import style0 from "./SendBackProvider.vue?vue&type=style&index=0&id=4338ce0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338ce0e",
  null
  
)

export default component.exports